"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTranslations;

var _react = _interopRequireDefault(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _ConfigProvider = require("../providers/ConfigProvider");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Given some `text` with variables (maybe) in it, those variables
 * having the form {name}, replace the variables with the matching
 * values from the map of `substitutions`.
 *
 * If any of the substitution values are React elements (instead of
 * plain text), then the result will be a React element. If not, then
 * the result will be plain text.
 *
 * @example
 *    replaceVars('Some {text} in {here}', { text: 'stuff', here: 'there' })
 *    => 'Some stuff in there'
 *
 * @example
 *    replaceVars('Some {other} stuff', { other: <b>bold</b> })
 *    => <Fragment>Some <b>bold</b> stuff</Fragment>
 */


function replaceVars(text, substitutions) {
  if (!substitutions || Object.keys(substitutions).length === 0) {
    return text;
  } // the substitution keys will just be plain strings - "foo"
  // but we have to look for them in `text` wrapped in brackets - "{foo}"
  // so we create a copy of the substitutions with the keys renamed as such.


  var variableSubs = Object.keys(substitutions).reduce(function (acc, key) {
    return _objectSpread({}, acc, {}, _defineProperty({}, "{".concat(key, "}"), substitutions[key]));
  }, {});
  var varNames = Object.keys(variableSubs);
  var regex = new RegExp(varNames.join('|'), 'gi');
  var matches = text.match(regex);

  if (!matches) {
    return text;
  } // If any of our substitution values are React elements, then we'll return
  // a React element from this function; otherwise stick to simple strings.


  var useReact = Object.values(variableSubs).some(function (v) {
    return _react.default.isValidElement(v);
  });
  var parts = text.split(regex);
  var results = parts.map(function (part, index) {
    var subValue = matches[index] ? variableSubs[matches[index]] : '';
    return useReact ? // eslint-disable-next-line react/no-array-index-key
    _react.default.createElement(_react.default.Fragment, {
      key: index
    }, part, subValue) : "".concat(part).concat(subValue);
  });
  return useReact ? _react.default.createElement(_react.default.Fragment, null, results) : results.join('');
}

function useTranslations() {
  var _useConfig = (0, _ConfigProvider.useConfig)(),
      translations = _useConfig.translations;

  return function translate(defaultValue, translationsPath) {
    var substitutions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (defaultValue) {
      return defaultValue;
    }

    return replaceVars((0, _get.default)(translations, translationsPath, ''), substitutions);
  };
}